<div class="layout-topbar pb-0" style="padding-left: 7px">
  <div class="flex justify-content-between h-full">
    <div class="flex align-items-center" style="padding-left: 7px; gap: 7px">
      <div class="cursor-pointer" (click)="switchMenu()">
        <a class="icon-white"><i class="pi pi-bars topbar-icon"></i></a>
      </div>
      <a [routerLink]="'/'">
        <img
          id="topbar-logo"
          src="assets/logo/logotipo_horizontal_lite_nealis_tech.svg"
          alt="Nealis Tech"
        >
      </a>
    </div>

    <div class="flex align-items-center h-full">
      <p-avatar
        [style.margin-bottom]="'2px'"
        (click)="op.show($event)"
        pRipple
        styleClass="topbar-avatar"
        class="cursor-pointer mr-2"
        icon="pi pi-user"
        shape="circle"
      ></p-avatar>
      <p-overlayPanel #op>
        <ng-template pTemplate>
          <div class="flex flex-column user-overlay" style="min-height: 50px;">
            <div class="flex flex-column sm:flex-row justify-content-between" style="min-height: 50px;">
              <div class="flex flex-column ml-2">
                <p style="margin-bottom: 6px;" class="py-0 mt-0 bold" *ngIf="userData.name">{{userData.name}}</p>
                <p style="margin-bottom: 6px;" class="py-0 mt-0">{{userData.username}}</p>
                <p style="margin-bottom: 6px;" class="py-0 mt-0">{{userData.email}}</p>
                <p class="py-0 mt-0">
                  {{preferences?.tenant}}
                  {{preferences?.organization ? ' (' + preferences.organization + ')' : ''}}
                </p>
              </div>
              <p-divider layout="vertical" class="hidden sm:block mx-3"></p-divider>
              <p-divider layout="horizontal" class="sm:hidden block mx-3"></p-divider>
              <div class="flex flex-column sm:justify-content-between sm:text-right sm:align-items-end">
                <div class="flex align-items-center" style="margin-top: 2px;">
                  <a class="sm:my-0 mr-2 ml-2 sm:ml-0 bold" [href]="userData.portalUrl" target="_blank">
                    {{'common.myAccount' | transloco}}
                  </a>
                </div>
                <div class="flex align-items-center">
                  <p (click)="logout()" class="cursor-pointer py-0 mt-2 sm:my-0 mr-2 ml-2 sm:ml-0 bold">
                    {{'common.logout' | transloco}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-overlayPanel>
    </div>
  </div>
</div>
